<template>
	<div class="menu-list" :id="id">
		<div class="menu-list__title">
			<SvgIcon
				v-if="icon"
				class="menu-list__title-icon"
				:icon="icon"
				:color="iconColor"
			/>
			<h2 class="menu-list__title-text" v-if="title">{{ title }}</h2>
		</div>
		<component
			v-for="menu in menus"
			:is="menu.fields.combos ? 'ComboCardList' : 'MenuItem'"
			:key="menu.id"
			:fields="menu.fields"
			:rendering="menu.rendering"
		></component>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});
const menus = computed(() => props.fields?.menus);
const title = computed(() => props.fields?.title?.value);
const icon = computed(() => props.fields?.icon?.value);
const iconColor = computed(() => props.fields?.iconColor?.value);
const id = computed(() => props.fields?.id?.value);
</script>

<style lang="scss">
.menu-list {
	scroll-margin-top: calc(var(--header-height, 54px) + 16px);
	margin: var(--spacing-5, 40px) var(--spacing-2, 16px);

	.menu-list__title {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.menu-list__title-text {
		color: var(--color-white, #fff);
		font-family: var(--primary-font, sans-serif);
		font-size: 28px;
		font-weight: 900;
		line-height: 110%;
		text-transform: uppercase;
	}

	.menu-list__title-icon {
		width: 40px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			padding: 0;
		}
	}

	.combo-card-list {
		padding: 0;
	}
}

.menu-details {
	list-style-type: none;
	padding: 0;
	margin: 0;

	.menu-detail {
		margin: 24px 0;
	}

	.menu-detail__title {
		color: #282828;
		font-family: var(--primary-font, sans-serif);
		font-size: var(--text-base, 16px);
		font-weight: 300;
		line-height: 140%;
		display: flex;
		align-items: flex-end;
		justify-content: space-between;

		& > span:nth-child(1) {
			min-width: fit-content;
			padding-right: var(--spacing-05, 4px);
		}

		& > span:nth-child(2) {
			width: 100%;
			border-bottom: 1px dashed #282828;
			margin-bottom: 6px;
		}

		& > span:nth-child(3) {
			padding-left: var(--spacing-05, 4px);
		}
	}

	.menu-detail__description {
		color: #767676;
		font-family: var(--primary-font, sans-serif);
		font-size: var(--text-2xs, 10px);
		font-weight: 300;
		line-height: 140%;
		margin: 12px auto;
	}
}

.menu-section {
	border-radius: 20px;
	padding: var(--spacing-3, 24px) var(--spacing-2, 16px);

	h3 {
		font-size: var(--text-lg, 20px);
		font-weight: 700;
		line-height: 120%;
		margin: 0 0 var(--spacing-3, 24px);
	}

	.menu-detail:last-child {
		margin-bottom: 0;

		p {
			margin-bottom: 0;
		}
	}
}
</style>
